var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"the-nothing-found-stub"},[_c('h2',{staticClass:"the-nothing-found-stub__headline"},[_vm._v(" Ничего не найдено ")]),_c('p',{staticClass:"the-nothing-found-stub__description"},[_vm._v(" По вашему запросу мы не смогли найти ни одной статьи ")])])
}]

export { render, staticRenderFns }